export default {
  first_nav: 0,
  is_login: 1,
  shidao_firstTab: 1,
  zhaiquanTab: 1
}



// WEBPACK FOOTER //
// ./src/vuex/states.js